export default "__VITE_ASSET__mTzokUNK__"